// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "nasServicesRefund-1EEhe";
var _5 = "nasServicesActions-Z6Na8";
var _6 = "agree-3GIut";
var _7 = "buttons-3uS1Z";
var _8 = "confirm-1K1VO";
var _9 = "cancel-2TQgQ";
var _a = "nasServices-9QwkT";
var _b = "checkbox-1-8S9";
var _c = "active-p0-zs";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "nasServicesRefund", _5 as "nasServicesActions", _6 as "agree", _7 as "buttons", _8 as "confirm", _9 as "cancel", _a as "nasServices", _b as "checkbox", _c as "active" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "nasServicesRefund": _4, "nasServicesActions": _5, "agree": _6, "buttons": _7, "confirm": _8, "cancel": _9, "nasServices": _a, "checkbox": _b, "active": _c }
